export default {"src":"/_next/static/media/barcode.2fc7c397.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};